import { render, staticRenderFns } from "./FormasDePago.vue?vue&type=template&id=12e53d0d&scoped=true&"
import script from "./FormasDePago.vue?vue&type=script&lang=js&"
export * from "./FormasDePago.vue?vue&type=script&lang=js&"
import style0 from "./FormasDePago.vue?vue&type=style&index=0&id=12e53d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e53d0d",
  null
  
)

export default component.exports